const COMPONENT_RE = /\{component\s+type="([^"]+)"(?:\s+data='((?:[^'\\]|\\.)*)')?\s*\}/g;
const PAGE_META_RE = /\{page:(\w+)\}/g;
const ALL_RE = /\{component\s+type="([^"]+)"(?:\s+data='((?:[^'\\]|\\.)*)')?\s*\}|\{page:(\w+)\}/g;

export function parseTemplate(html) {
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = ALL_RE.exec(html)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'html', html: html.slice(lastIndex, match.index) });
    }
    if (match[1] !== undefined) {
      parts.push({
        type: 'component',
        componentType: match[1],
        data: match[2] ? JSON.parse(match[2]) : {},
      });
    } else {
      parts.push({ type: 'page-meta', key: match[3] });
    }
    lastIndex = ALL_RE.lastIndex;
  }
  if (lastIndex < html.length) {
    parts.push({ type: 'html', html: html.slice(lastIndex) });
  }
  return parts;
}
